import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/competitionsettings`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer tous les settings de compétition
export const getAllCompetitionSettings = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allCompetitionSettings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error(
      "Erreur lors du chargement des settings de compétition:",
      error
    );
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour récupérer un setting de compétition avec son id
export const getCompetitionSettingById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/competition/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.status !== 200) throw new Error("Failed to fetch data");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error(
      "Erreur lors du chargement du setting de compétition:",
      error
    );
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

// Fonction pour afficher les settings d'une compétition avec son id
export const getCompetitionSettingsByCompetitionId = async (competitionId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/competitionSettings/${competitionId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status !== 200)
      throw new Error("Failed to fetch user competitions");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error(
      "Erreur lors du chargement des settings de la compétition:",
      error
    );
    return []; // Renvoie un tableau vide en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// POST
// Fonction pour ajouter un setting de compétition
export const addCompetitionSetting = async (newCompetitionSetting) => {
  try {
    const response = await axios.post(
      `${apiUrl}/addCompetitionSettings`,
      newCompetitionSetting,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Vérifie la présence d’un ID ou autre clé importante dans la réponse
    if (!response.data || !response.data.id) {
      throw new Error("Réponse invalide après création du setting");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout du setting de compétition:", error);

    // Cas où la création a réussi malgré une erreur Axios
    if (error.response?.data?.id) {
      console.warn(
        "⚠️ Réponse considérée comme erreur mais le setting a été créé :",
        error.response.data
      );
      return error.response.data;
    }

    return null;
  }
};


/// PUT
// Fonction pour modifier un setting de compétition
export const updateCompetitionSetting = async (
  id,
  updatedCompetitionSetting
) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateCompetitionSettings/${id}`,
      updatedCompetitionSetting,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status !== 200)
      throw new Error("Failed to update competition setting");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error(
      "Erreur lors de la modification du setting de compétition:",
      error
    );
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};

/// DELETE
// Fonction pour supprimer un setting de compétition
export const deleteCompetitionSetting = async (id) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/deleteCompetitionSettings/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (response.status !== 200)
      throw new Error("Failed to delete competition setting");
    return response.data; // Renvoie directement les données
  } catch (error) {
    console.error(
      "Erreur lors de la suppression du setting de compétition:",
      error
    );
    return null; // Renvoie null en cas d'échec pour maintenir la cohérence du type de retour
  }
};
